import { css } from 'lit';
export const vars = css `
  --spacing-xs: 4px;
  --spacing-s: 8px;
  --spacing-n: 16px;
  --spacing-m: 20px;
  --spacing-l: 24px;
  --spacing-xl: 32px;
  --spacing-xxl: 40px;
`;
export const spacing = css `
  :host {
    ${vars}
  }
`;
export default spacing;
